import request from "@/utils/request";
import getLocale from "@/utils/locale";

export default ({
  token,
  code,
  zip,
  countryCode,
  currency,
  seats,
  productType = "subscriptions"
} = {}) => {
  let url = `/api/${ productType === "teams" ? "teams_" : "" }plans`;
  const params = {
    locale: getLocale()
  };
  if (token) {
    url += `/${token}`;
  }
  if (code) {
    params["coupon_code"] = code;
  }
  if (countryCode) {
    params["country"] = countryCode;
  }
  if (zip) {
    params["postal_code"] = zip;
  }
  if (currency) {
    params["currency"] = currency;
  }
  if (seats) {
    params["seats"] = seats;
  }
  return request
    .get(url, {
      params,
      token: true
    });
};
